export function scrollToId(id) {
  const target = document.getElementById(id);
  if (!target) return;
  const lenis = window.__NIYATI_LENIS__;
  if (lenis) {
    lenis.scrollTo(target, { offset: -96, duration: 1.15 });
    return;
  }
  target.scrollIntoView({ behavior: "smooth", block: "start" });
}
